import { render, staticRenderFns } from "./BaseRadioGroup.vue?vue&type=template&id=cdd803b0&scoped=true&"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js&"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseRadioGroup.vue?vue&type=style&index=0&id=cdd803b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd803b0",
  null
  
)

export default component.exports